import React, { useState } from 'react';
import * as Yup from 'yup';
import {
	Box,
	HStack,
	Text,

	Button,

} from '@chakra-ui/react'
import { InputText, Form } from '../../components/form'
import { toast } from "react-toastify";
import { fetchWrapper } from '../../helpers';

function ChangePassword({ meCloseEdit, loadList, rs }) {



	const [formData, setFormData] = useState({
		password: '',
		confirmPassword: '',
		id: rs.id,


	});

	const FormSchema = Yup.object().shape({

		password: Yup.string()
			.min(8, 'Password must be at least 8 characters')
			.matches(/\d/, 'Password must contain at least one digit')
			.matches(/[a-zA-Z]/, 'Password must contain at least one letter')
			.matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character')
			.required('Password is required'),
		confirmPassword: Yup.string()
			.oneOf([Yup.ref('password'), null], 'Passwords must match') // Ensure passwords match
			.required('Required'),

	});








	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {

		let data = { ...values };
		delete data.confirmPassword;


		const url = `${process.env.REACT_APP_API_URL}/user/password-change`;
		await fetchWrapper.post(url, data)
		loadList()
		meCloseEdit();
		toast(`Record has been update `, {
			type: "info"
		});
	}

	return (
		<>

			<Form
				enableReinitialize
				validationSchema={FormSchema}
				initialValues={formData}
				onSubmit={onSubmit}
			>
				<HStack mb="20px">
					<Box>User ID	 :</Box>
					<Box>
						<Text>{rs.email}</Text>
					</Box>
				</HStack>
				<Box mb="10px">
					<InputText name="password" title="Password" inputProps={{ type: 'password', isRequired: true }} />
				</Box>

				<Box mb="10px">
					<InputText name="confirmPassword" title="Confirm Password" inputProps={{ type: 'password', isRequired: true }} />
				</Box>





				<Button className='custom-chakra-button' py="10px" px="25px" color="#fff" bg="var(--brand-primary)" fontSize="14px" fontWeight="500" fontFamily="'Lato', sans-serif"
					mb={4}

					type='submit'
				>
					Update password
				</Button>
			</Form>

		</>
	)
}

export default ChangePassword;